import { ReferralClosingBanner, ReferralHero, ReferralHowItWorks } from '@referral/presentation/components';
import { useReferralWhatsappLink } from '@referral/presentation/hooks';

/**
 * Referral landing page ("Recomienda Parrot").
 *
 * Renders inside the app frame. Composes the hero, the how-it-works steps and the closing
 * banner; both CTAs open the same WhatsApp conversation built from the current store name.
 *
 * @returns {React.ReactElement} The referral page
 */
export const ReferralPage = () => {
  const whatsappLink = useReferralWhatsappLink();

  return (
    <div className="flex min-h-screen w-full flex-col font-sans">
      <div className="m-auto flex w-full max-w-5xl flex-col gap-12 px-4 py-10 md:px-6 md:py-14">
        <ReferralHero whatsappLink={whatsappLink} />
        <ReferralHowItWorks />
        <ReferralClosingBanner whatsappLink={whatsappLink} />
      </div>
    </div>
  );
};
